import {Container, Row, Col} from 'react-bootstrap';
import {Trans} from 'react-i18next';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFacebook, faLinkedin, faInstagram} from '@fortawesome/free-brands-svg-icons';

import './styles.scss';

export const LandingPageFooter = () => (
    <footer className="LandingFooter bg-dark text-white pt-5 px-4">
        <Container>
            <Row className="gy-4 justify-content-center justify-content-md-between text-center text-md-start">
                <Col xs={12} md={4} className="mb-3">
                    <h5 className="mb-3"><Trans>Contact Us</Trans></h5>
                    <p className="mb-1"><Trans>General Enquiries:</Trans> hello@youngeyes.co</p>
                    <p className="mb-0"><Trans>Support:</Trans> support@youngeyes.co</p>
                </Col>
                <Col xs={12} md="auto" className="mb-3">
                    <h5><Trans>Follow Us</Trans></h5>
                    <div className="Footer--socials">
                        <a href="https://www.facebook.com/profile.php?id=61570059332391#" className="text-white">
                            <FontAwesomeIcon icon={faFacebook} size="lg" />
                        </a>
                        <a href="https://www.linkedin.com/company/youngeyes/" className="text-white">
                            <FontAwesomeIcon icon={faLinkedin} size="lg" />
                        </a>
                        <a href="https://www.instagram.com/youngeyesfest" className="text-white">
                            <FontAwesomeIcon icon={faInstagram} size="lg" />
                        </a>
                    </div>
                </Col>
                <Col xs={12} md={4}>
                    <h5 className="mb-3"><Trans>About Us</Trans></h5>
                    <p className="mb-0">
                        <Trans>
                            Young Eyes is dedicated to providing entrepreneurial education for young and aspiring founders.
                            Follow our socials for more updates.
                        </Trans>
                    </p>
                </Col>
            </Row>
            <Row className="pt-4">
                <Col className="text-center">
                    <p className="mb-0">&copy; {new Date().getFullYear()} Young Eyes. All rights reserved.</p>
                </Col>
            </Row>
        </Container>
    </footer>
);
